<template>
<div class="imagemobile" id="img-splash-mobile">

<img src="" title="" alt="" class="img_mobile_occhio" onerror="this.src='https://vistosi.it/risorse/prodotto/IMGNOTFOUND.jpg'">
<div id="occhio-centrato-mobile" class="occhio-centrato-mobile"> 
        <a href="https://www.vistosi.it/test/"> 
         <input type="image" style="padding:0px;" src="https://vistosi.it/wp-content/uploads/2021/09/OCCHIO.svg"> 
       <h6 style="color:#686868; max-width:100px; text-align: center;">Vedi nel museo </h6>
         </a> 
    </div>
</div>

</template>
<script>
export default {
    name:'imagemobile',
    computed: {

    },
}
</script>
<style scoped>
.imagemobile{
    max-width: 100%;
    z-index: 100 !important;
}
#img-splash-mobile img{
max-width: 100%;
}


.imagemobile #occhio-centrato-mobile a{
        display: flex;
    align-items: center;
}
.imagemobile #occhio-centrato-mobile h6{
        padding-left: 5px
}
@media only screen and (min-width: 1025px) {
.imagemobile{
   display: none !important;
}
}
@media only screen and (max-width: 1025px) {
.imagemobile #occhio-centrato-mobile, .imagemobile .occhio-centrato {
       position: relative !important;
    top: -85px !important;
    left: 64vh  !important;
    display: flex !important;

}
}
</style>